import { Injectable } from '@angular/core';

import { ApplicationConfiguration } from '@core/configuration';

@Injectable({
    providedIn: 'root'
})
export class B2cAuthorityService {
    constructor(private applicationConfig: ApplicationConfiguration) { }

    public get signUpSignInAuthority(): string {
        return this.buildAuthority(this.applicationConfig.azureB2c.signUpSignIn);
    }

    public get resetPasswordAuthority(): string {
        return this.buildAuthority(this.applicationConfig.azureB2c.resetPassword);
    }

    public get switchTenantAuthority(): string {
        return this.buildAuthority(this.applicationConfig.azureB2c.switchTenant);
    }

    public getPolicyAuthorities(): Record<string, string> {
        const config = this.applicationConfig.azureB2c;
        if (!config) {
            return {};
        }

        const authorities: Record<string, string> = {};
        authorities[(config.signUpSignIn || '').trim().toLowerCase()] = this.buildAuthority(config.signUpSignIn);
        authorities[(config.resetPassword || '').trim().toLowerCase()] = this.buildAuthority(config.resetPassword);
        authorities[(config.editProfile || '').trim().toLowerCase()] = this.buildAuthority(config.editProfile);

        if (config.switchTenant) {
            authorities[(config.switchTenant || '').trim().toLowerCase()] = this.buildAuthority(config.switchTenant);
        }

        return authorities;
    }

    private buildAuthority(policy: string | undefined): string {
        if (!this.applicationConfig.azureB2c) {
            return '';
        }

        return `https://${this.applicationConfig.azureB2c.instance}/${this.applicationConfig.azureB2c.domain}/${policy}`;
    }
}